import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { css } from "styled-components";

Object.assign(addressInfoDisplayStyles, {
    wrapper: {
        css: css`
            font-style: normal;
            font-size: 13px;
            font-weight: 500;
        `,
    },
});
